import { Link } from 'react-router-dom';
import { NavbarVariantEnum } from 'src/types';
import styled from 'styled-components';

export const PublicReportCardContainer = styled.div<{
  fullWidth?: boolean;
  variant?: NavbarVariantEnum;
}>`
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.7);
  box-shadow: 0px 0px 11px -1px rgba(150, 150, 150, 0.3);
  width: ${(props) =>
    props.variant === NavbarVariantEnum.PUBLIC ? '98%' : '85%'};
  height: min-content;
  color: ${(props) => props.theme.newPalette.neutral.N800};
  font-size: 12px;
  text-decoration: none;
  display: flex;
  margin-top: 20px;
  ${(props) => !props.fullWidth && 'user-select: none;'}
  @media screen and (min-width: 0px) and (max-width: 480px) {
    flex-direction: column;
    ${(props) =>
      props.fullWidth &&
      'width: 100%; margin-top: 0; border-radius: 0; padding: 10px 0px;'}
  }
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    height: min-content;
    padding-bottom: 10px;
  }
`;

export const Bottom = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: calc(100% - 40px);
  margin: 0px 20px 0px 20px;
  padding: 10px 0px;
  border-top: 1px solid rgba(150, 150, 150, 0.3);
`;

export const TextLink = styled(Link)`
  color: ${(props) => props.theme.newPalette.turquoise.T300};
  margin: 5px;
  text-decoration: none;
  ${(props) => props.theme.newTypography.textStyleBodySmall}
`;

export const MobileOnlyWrapper = styled.div`
  display: none;
  @media screen and (min-width: 0px) and (max-width: 480px) {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    gap: 16px;
    flex-direction: column;
  }
`;
